/*'asc' 'desc'
 *ngFor="let c of oneDimArray | sortBy:'asc'"
 *ngFor="let c of arrayOfObjects | sortBy:'asc':'propertyName'"
*/
import { Pipe, PipeTransform } from '@angular/core';
import { orderBy, get } from 'lodash';

@Pipe({ name: 'sortBy' })
export class SortByPipe implements PipeTransform {

  transform(value: any[], order = '', column: string = ''): any[] {
    if (!value || !Array.isArray(value)) return value;
    if (!order || !column || value.length <= 1) return value;

    return orderBy(
      value,
      [(item) => {
        const val = get(item, column);
        return typeof val === 'string' ? val.toLowerCase() : val;
      }],
      [order]
    );
  }
}
